<script setup lang="ts">
import merge from 'lodash-es/merge';
import type { ListItemModel as SectionListItemModel } from '#layers/prawopl/app/pages/cms/modules/wk-sections/_runtime/services/SectionsService';
import SectionsService from '#layers/prawopl/app/pages/cms/modules/wk-sections/_runtime/services/SectionsService';

defineOptions({
    name: 'WkArticlesPrioritySectionSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue',): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    sectionId: 0
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

watch(() => form.value.settings, () =>
{
    triggerModel();
},
{ deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function fetchSection(id: number): Promise<SectionListItemModel>
{
    const response = await SectionsService.fetchAutocomplete(id);

    return response || null;
}

async function searchSection(query: string, limit: number): Promise<SectionListItemModel[]>
{
    return await SectionsService.getAutocomplete(query, limit, [], true);
}
onBeforeMount((): void =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup class="col-md-12" :label="$t('[[[Wybierz sekcję]]]')" :invalid-feedback="form.$errors.first('settings.sectionId')" :state="form.$errors.state('settings.sectionId')" required>
        <IdeoAutocomplete
            v-model="form.settings.sectionId"
            name="sectionId"
            track-by="id"
            :placeholder="$t('[[[Wyszukaj sekcję...]]]')"
            :default-label="$t('[[[Brak sekcji]]]')"
            :fetch="(id: number) => fetchSection(id)"
            :search="(query: string, limit: number) => searchSection(query, limit)"
        >
            <template #selected="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
            <template #option="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
        </IdeoAutocomplete>
    </IdeoFormGroup>
</template>
